export const GhgRoutes = {
    SaveGhgVerification: "Ghg/SaveGhgVerification",
    SaveClientGhgVerification: "Ghg/SaveClientGhgVerification",
    GenerateExternalGhgVerification: "Ghg/GenerateExternalGhgVerification",
    GetVesselPendingGhgVerification: "Ghg/GetVesselPendingGhgVerification",
    GetGhgVerification: "Ghg/GetGhgVerification",
    GetGhgVerificationRatingFactorsClientModel: "Ghg/GetGhgVerificationRatingFactorsClientModel",
    GetGhgVerificationEexiFactorsClientModel: "Ghg/GetGhgVerificationEexiFactorsClientModel",
    GetGhgVerificationCiiFactorsClientModel: "Ghg/GetGhgVerificationCiiFactorsClientModel",
    GetGhgVerificationEnergySavingEquipments: "Ghg/GetGhgVerificationEnergySavingEquipments",
    GetGhgVerificationCii: "Ghg/GetGhgVerificationCii",
    GetGhgVerificationStatusClientModel: "Ghg/GetGhgVerificationStatusClientModel",
    SaveGhgVerificationRatingFactors: "Ghg/SaveGhgVerificationRatingFactors",
    ComputeRevisedGhg: "Ghg/ComputeRevisedGhg",
    SaveGhgRatingFactorSourceComment: "Ghg/SaveGhgRatingFactorSourceComment",
    SaveGhgEnergySavingEquipmentComment: "Ghg/SaveGhgEnergySavingEquipmentComment",
    SaveGhgVerificationEexiComment: "Ghg/SaveGhgVerificationEexiComment",
    SaveGhgVerificationCiiComment: "Ghg/SaveGhgVerificationCiiComment",
    SaveGhgVerificationEnergySavingEquipments: "Ghg/SaveGhgVerificationEnergySavingEquipments",
    SaveGhgVerificationEexi: "Ghg/SaveGhgVerificationEexi",
    SaveGhgVerificationCii: "Ghg/SaveGhgVerificationCii",
    ChangeStatus: "Ghg/ChangeStatus",
    GetGhgVerificationClientModel: "Ghg/GetGhgVerificationClientModel",
    GetGhgVerificationByGuid: "Ghg/GetGhgVerificationByGuid",
    GetGhgCorrespondenceEmails: "Ghg/GetGhgCorrespondenceEmails",
    GetHasUnacceptableCiiRatings: "Ghg/GetHasUnacceptableCiiRatings",
    GetEnvironmentalVerificationSettings: "Ghg/GetEnvironmentalVerificationSettings",
    SendInviteToDoc: "Ghg/SendInviteToDoc",
    SubmitGhgRatingChange: "Ghg/SubmitGhgRatingChange",
    ValidateEmailDomain: "Ghg/ValidateEmailDomain",
    DoesVesselCiiExist: "Ghg/DoesVesselCiiExist",
    GetEstimatedCii: "Ghg/GetEstimatedCii",
    GetPaintTypes: "Ghg/GetPaintTypes",
    GetHullPreparationStandards: "Ghg/GetHullPreparationStandards",
    GetPaintManufacturers: "Ghg/GetPaintManufacturers",
    GetClassificationSocieties: "Ghg/GetClassificationSocieties"
}